import { Card, Checkbox, CrudMode, DataDisplay, Grid, GridBreak, Stack, ValidationErrors, formatMinutes, pn, useElementBreakpoints } from "@compass/core";
import { DatePicker, DurationInput, Select } from "components";
import {
  ContributorMatch,
  ContributorMatchBulkUpdate,
  ContributorMatchBulkUpdateResource,
  ContributorMatchBulkUpdateSchema,
} from "generated/openApi";
import { MatchFiles } from "./MatchFiles";
import produce from "immer";

export const MatchUpdateSchema = (props: {
  // crudMode: CrudMode;
  // match: ContributorMatch;
  // setMatch: (value: ContributorMatch) => void;
  updateSchema: ContributorMatchBulkUpdateSchema;
  setUpdateSchema: (value: ContributorMatchBulkUpdateSchema) => void;
  resource: ContributorMatchBulkUpdateResource;
  validationErrors: ValidationErrors | string[];
}) => {
  const { breakpointsRef, setBreakpoints, smallFieldBreakpoints, mediumFieldBreakpoints, largeFieldBreakpoints, fullFieldBreakpoints } =
    useElementBreakpoints();
  const properties =
    props.resource.properties?.find((x) => x.propertyName === pn<ContributorMatchBulkUpdate>("updateSchema"))
      ?.children || [];

  const dateField = () => {
    const propertyName = pn<ContributorMatchBulkUpdateSchema>("date");
    const property = properties.find((x) => x.propertyName === propertyName);
    const isUpdating = props.updateSchema.updateDate;

    return (
      <Stack direction="row" alignItems="center" spacing="sm">
        <Checkbox
          checked={isUpdating}
          onChange={(e) => props.setUpdateSchema({ ...props.updateSchema, updateDate: e.target.checked })}
        />

        <DatePicker
          modelProperty={property}
          required={isUpdating}
          errors={props.validationErrors[propertyName]}
          value={props.updateSchema.date}
          onChange={(value) => props.setUpdateSchema({ ...props.updateSchema, date: value })}
          disabled={!isUpdating}
        />
      </Stack>
    );
  };

  const durationInMinutesField = () => {
    const propertyName = pn<ContributorMatchBulkUpdateSchema>("durationInMinutes");
    const property = properties.find((x) => x.propertyName === propertyName);
    const isUpdating = props.updateSchema.updateDurationInMinutes;

    return (
      <Stack direction="row" alignItems="center" spacing="sm">
        <Checkbox
          checked={isUpdating}
          onChange={(e) => props.setUpdateSchema({ ...props.updateSchema, updateDurationInMinutes: e.target.checked })}
        />

        <DurationInput
          disabled={!isUpdating}
          label={property?.displayName}
          required={property?.required}
          errors={props.validationErrors[propertyName]}
          value={props.updateSchema.durationInMinutes}
          onChange={(value) =>
            props.setUpdateSchema(
              produce(props.updateSchema, (draft) => {
                draft.durationInMinutes = value!;
              })
            )
          }
        />
      </Stack>
    );
  };

  const serviceField = () => {
    const propertyName = pn<ContributorMatchBulkUpdateSchema>("serviceId");
    const property = properties.find((x) => x.propertyName === propertyName);
    const isUpdating = props.updateSchema.updateServiceId;

    return (
      <Stack direction="row" alignItems="center" spacing="sm">
        <Checkbox
          checked={isUpdating}
          onChange={(e) => props.setUpdateSchema({ ...props.updateSchema, updateServiceId: e.target.checked })}
        />

        <Select
          modelProperty={property}
          errors={props.validationErrors[propertyName]}
          value={props.resource.services?.find((x) => x.id === props.updateSchema.serviceId)}
          options={props.resource.services}
          getOptionLabel={(option) => option.name}
          onChange={(e, value) => props.setUpdateSchema({ ...props.updateSchema, serviceId: value?.id })}
          disabled={!isUpdating}
        />
      </Stack>
    );
  };

  return (
    <Card header="Updating Fields">
      <Grid ref={breakpointsRef} container spacing="sm">
        <Grid item xs={largeFieldBreakpoints}>
          {serviceField()}
        </Grid>

        <GridBreak />

        <Grid item xs={mediumFieldBreakpoints}>
          {durationInMinutesField()}
        </Grid>

        <GridBreak />

        <Grid item xs={smallFieldBreakpoints}>
          {dateField()}
        </Grid>

        <Grid item xs={12}>
          <MatchFiles
            files={props.updateSchema.creatingFiles || []}
            setFiles={(files) => props.setUpdateSchema({ ...props.updateSchema, creatingFiles: files })}
          />
        </Grid>
      </Grid>
    </Card>
  );
};
